import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import KanbanBoard from "../KanbanBoard/KanbanBoard";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AdminDashboard.css"


const UserDashboard = () => {
  const [admin, setAdmin] = useState({
    name: "Admin",
    email: "admin@gmail.com",
    profilePic: "https://github.com/mdo.png", // Default profile pic
  });
  const dropdownRefProfile = useRef(null);
  const dropdownRefFilter = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [buckets, setBuckets] = useState([]);
  const [users, setUsers] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const [progressOptions, setProgressOptions] = useState([]);
  const [showDropdownfilter, setShowDropdownfilter] = useState(false);
  const [showDueDateSubmenu, setShowDueDateSubmenu] = useState(false);  
  const [showPrioritySubmenu, setPrioritySubmenu] = useState(false);
  const [showProgressSubmenu, setProgressSubmenu] = useState(false);
  const [showLabelsSubmenu, setLabelsSubmenu] = useState(false);
  const [showBucketsSubmenu, setBucketsSubmenu] = useState(false);
  const [showAssignmentSubmenu, setAssignmentSubmenu] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [fileError, setFileError] = useState("");
  const [touched, setTouched] = useState(false);
  const [filters, setFilters] = useState({
    dueDate: null,
    priority: null,
    progress: null,
    bucket: null,
    assignment: null,
  });
  const [profileData, setProfileData] = useState({
    name: admin.name,
    profilePic: null,
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [passwordErrors, setPasswordErrors] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [changePasswordMode, setChangePasswordMode] = useState(false);
  const [oldPasswordVerified, setOldPasswordVerified] = useState(false);
  const navigate = useNavigate();
  
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (
            dropdownRefProfile.current &&
            !dropdownRefProfile.current.contains(event.target)
          ) {
            setShowDropdown(false);
          }
          if (
            dropdownRefFilter.current &&
            !dropdownRefFilter.current.contains(event.target)
          ) {
            setShowDropdownfilter(false);
            setShowDueDateSubmenu(false);
            setPrioritySubmenu(false);
            setProgressSubmenu(false);
            setLabelsSubmenu(false);
            setBucketsSubmenu(false);
            setAssignmentSubmenu(false);
          }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);

  // ✅ Fetch buckets
  useEffect(() => {
    axios.get("https://teams.tidyds.com/api/buckets", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    })
    .then(res => setBuckets(res.data))
    .catch(err => console.error("Error fetching buckets:", err));

    // ✅ Fetch users (assignments)
    axios.get("https://teams.tidyds.com/api/users", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    })
    .then(res => setUsers(res.data))
    .catch(err => console.error("Error fetching users:", err));
  }, []);  
    useEffect(() => {
    axios.get("https://teams.tidyds.com/api/tasks", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    })
    .then(res => {
      const tasks = res.data;

      // ✅ Unique priorities
      const uniquePriorities = [...new Set(tasks.map(t => t.priority).filter(Boolean))];
      setPriorities(uniquePriorities);

      // ✅ Unique progress/status
      const uniqueStatuses = [...new Set(tasks.map(t => t.status).filter(Boolean))];
      setProgressOptions(uniqueStatuses);
    })
    .catch(err => console.error("Error fetching tasks:", err));
  }, []);
 
  useEffect(() => {
    if (!showProfileModal) {
      setProfileData({
        profilePic: null,
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      setChangePasswordMode(false);
      setOldPasswordVerified(false);
      setPasswordErrors({ newPassword: "", confirmPassword: "" });
    }
  }, [showProfileModal]);


  // ✅ Fetch Profile Data from Laravel API
  useEffect(() => {
    axios
      .get("https://teams.tidyds.com/api/profile", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setAdmin({
          name: response.data.name,
          email: response.data.email,
          profilePic: response.data.profile_pic
            ? `https://teams.tidyds.com${response.data.profile_pic}`
            : "https://github.com/mdo.png", // Fallback image
        });
        setProfileData({ name: response.data.name, profilePic: null, oldPassword: "", newPassword: "", confirmPassword: "",});
      })
      .catch((error) => {
        console.error("Error fetching profile:", error);
      });
  }, []);

  // ✅ Handle Profile Changes
  const handleProfileChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "profilePic" && files[0]) {
      const file = files[0];

      if (file.size > 300 * 1024) {
        setFileError("File size must not exceed 300KB.");
        setProfileData({ ...profileData, profilePic: null });
        return;
      } else {
        setFileError(""); // clear error
        setProfileData({ ...profileData, profilePic: file });
      }
    } else {
      setProfileData({ ...profileData, [name]: value });
    }
  };

  const verifyOldPassword = async () => {
    try {
      const response = await axios.post(
        "https://teams.tidyds.com/api/verify-password",
        { password: profileData.oldPassword },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.data.valid) {
        setOldPasswordVerified(true);
        toast.success("Old password verified. Please enter your new password.");
      } else {
        alert("Old password is incorrect.");
      }
    } catch (error) {
      console.error("Password verification error:", error);
      toast.error("Please Enter Valid Password.");
    }
  };
  // ✅ Save Profile Updates
const handleProfileUpdate = async () => {
  if (changePasswordMode && oldPasswordVerified) {
    if (!profileData.newPassword || !profileData.confirmPassword) {
      toast.error("Please fill in both new password fields.");
      return;
    }
    if (profileData.newPassword !== profileData.confirmPassword) {
      toast.error("New passwords do not match.");
      return;
    }
  }

  const formData = new FormData();
  formData.append("name", profileData.name);

  // ✅ Append new password if verified
  if (changePasswordMode && oldPasswordVerified) {
    let hasError = false;
    const newErrors = { newPassword: "", confirmPassword: "" };

    if (profileData.newPassword.length < 6) {
      newErrors.newPassword = "Password must be at least 6 characters.";
      hasError = true;
    }

    if (profileData.confirmPassword.length < 6) {
      newErrors.confirmPassword = "Confirm password must be at least 6 characters.";
      hasError = true;
    }

    if (profileData.newPassword !== profileData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
      hasError = true;
    }

    setPasswordErrors(newErrors);

    if (hasError) return;

    // 🚀 Append password to formData so Laravel can update it
    formData.append("password", profileData.newPassword);
  }

  if (profileData.profilePic) {
    formData.append("profile_pic", profileData.profilePic);
  }

  try {
    const response = await axios.post(
      "https://teams.tidyds.com/api/update-profile",
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success("Profile updated successfully!");
    setAdmin({
      ...admin,
      name: response.data.name,
      profilePic: response.data.profile_pic
        ? `https://teams.tidyds.com${response.data.profile_pic}?t=${Date.now()}`
        : admin.profilePic,
    });
    setShowProfileModal(false);
    setChangePasswordMode(false);
    setOldPasswordVerified(false);
  } catch (error) {
    console.error("Error updating profile:", error);
    toast.error("Failed to update profile.");
  }
};

  // ✅ Logout Function
  const handleLogout = () => {
    toast.info("Logging out...");
    localStorage.removeItem("token");
    setTimeout(() => {
      navigate("/");
    }, 1500); // 1.5 seconds
  };


  return (
    <div>
    <style>{`
      .rounded-circle{
      object-fit: cover;
      }
      .p-b:hover{
      background: #6b21bf !important;
      border-color: #6b21bf !important;
      color: #ffffff !important;
      }
      .profile-label:hover{
      background: #e8d8f8
      }
      .c-a-b {
        position: relative;
        display: inline-block;
      }

      .c-a-b::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 0;
        height: 1px;
        background-color: #45048a;
        transition: width 0.2s ease-in-out;
      }

      .c-a-b:hover::after {
        width: 100%;
      }
      .c-a-b::after {
        right: auto;
        left: 0;
      }
      .dropdown-item:focus{
      color:#000000}
      .profile-hover:hover{
      box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;}
      `}</style>
     <header className="header fixed-top border-bottom bg-white shadow-sm">
        <div className="container-fluid d-flex align-items-center justify-content-between">
          
          {/* Left: Logo + Title */}
          <div className="d-flex align-items-center">
            <img src="./tidy_logo.png" alt="Logo" className="logo me-2" />
            <div className="vr mx-2"></div>
            <h5 className="mb-0 taskplanner">Task Planner</h5>
          </div>
          
          

          {/* Right: Notification + Profile */}
          <div className="d-flex align-items-center">
            {/* Search */}
            <div className="flex-grow-1 d-flex ">
              <div className="input-group" style={{ maxWidth: "300px", width: "300px" , borderRadius:"8px", border: "1px solid #d5d7da"}}>
                <span className="input-group-text border-0" style={{ padding: "0px", marginRight:"10px", background: "#ffffff"}}>
                  <img src="./search-lg.png" alt="search" className="search-img"/>
                </span>
                <input
                  type="text"
                  className="form-control border-0 "
                  placeholder="Search"
                  style={{ padding: "0px", background: "#ffffff"}}
                />
              </div>
            </div>

            {/* 🔽 Filter Dropdown */}
            <div style={{paddingLeft:"24px"}} className="dropdown" ref={dropdownRefFilter}>
              <button
                className="btn p-0 border-0"
                title="Filter"
                onClick={() => setShowDropdownfilter(!showDropdownfilter)}
              >
                <img
                  src="./filter-funnel-01.png"
                  alt="Profile"
                  width="auto"
                  height="20"
                />
              </button>
              {showDropdownfilter && (
                <div 
                  className="dropdown-menu dropdown-menu-end show  shadow rounded-3 p-3" 
                  style={{ top:"64px", right:"0px", border:"1px solid #e9eaeb", width:"250px" }}
                >
                  
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h6 className="mb-0 fw-semibold">Filter</h6>
                    </div>
                    <div>
                      <h6 className="c-a-b mb-0" style={{fontSize:"14px", color:"#45048a", cursor:"pointer"}}
                      onClick={() =>
                        setFilters({
                          dueDate: null,
                          priority: null,
                          progress: null,
                          bucket: null,
                          assignment: null,
                        })
                      }
                    >
                      Clear all
                    </h6>

                    </div>
                  </div>

                  <hr className="my-2" />

                  {/* Action Items */}
                  <div className="dropdown-submenu">
                    <button
                      className="dropdown-item d-flex align-items-center justify-content-between"
                      style={{ padding: "8px 4px", fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowDueDateSubmenu(!showDueDateSubmenu);
                        setPrioritySubmenu(false);
                        setProgressSubmenu(false);
                        setBucketsSubmenu(false);
                        setAssignmentSubmenu(false);
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <img
                          src="./profile.png"
                          alt="profile"
                          className="profile-img"
                          style={{ height: "15px", width: "auto", marginRight: "8px" }}
                        />
                        Due date
                      </div><img src="./arrow.png" alt="arrow" style={{height:"14px", width:"auto"}} />
                    </button>

                    {showDueDateSubmenu && (
                      <div
                        className="dropdown-menu show shadow rounded-3 p-2"
                        style={{
                          position: "absolute",
                          top: "0",
                          right: "105%",
                          marginLeft: "5px",
                          border: "1px solid #e9eaeb",
                        }}
                      >
                        <button
                          className="dropdown-item"
                          style={{
                            backgroundColor: filters.dueDate === "late" ? "#45048a" : "transparent",
                            color: filters.dueDate === "late" ? "#fff" : "#000",
                          }}
                          onClick={() => setFilters({ ...filters, dueDate: "late" })}
                        >
                          Late
                        </button>
                        <button
                          className="dropdown-item"
                          style={{
                            backgroundColor: filters.dueDate === "today" ? "#45048a" : "transparent",
                            color: filters.dueDate === "today" ? "#fff" : "#000",
                          }}
                          onClick={() => setFilters({ ...filters, dueDate: "today" })}
                        >
                          Today
                        </button>
                        <button
                          className="dropdown-item"
                          style={{
                            backgroundColor: filters.dueDate === "tomorrow" ? "#45048a" : "transparent",
                            color: filters.dueDate === "tomorrow" ? "#fff" : "#000",
                          }}
                          onClick={() => setFilters({ ...filters, dueDate: "tomorrow" })}
                        >
                          Tomorrow
                        </button>
                        <button
                          className="dropdown-item"
                          style={{
                            backgroundColor: filters.dueDate === "this_week" ? "#45048a" : "transparent",
                            color: filters.dueDate === "this_week" ? "#fff" : "#000",
                          }}
                          onClick={() => setFilters({ ...filters, dueDate: "this_week" })}
                        >
                          This week
                        </button>
                        <button
                          className="dropdown-item"
                          style={{
                            backgroundColor: filters.dueDate === "next_week" ? "#45048a" : "transparent",
                            color: filters.dueDate === "next_week" ? "#fff" : "#000",
                          }}
                          onClick={() => setFilters({ ...filters, dueDate: "next_week" })}
                        >
                          Next week
                        </button>
                        <button
                          className="dropdown-item"
                          style={{
                            backgroundColor: filters.dueDate === "future" ? "#45048a" : "transparent",
                            color: filters.dueDate === "future" ? "#fff" : "#000",
                          }}
                          onClick={() => setFilters({ ...filters, dueDate: "future" })}
                        >
                          Future
                        </button>
                        <button
                          className="dropdown-item"
                          style={{
                            backgroundColor: filters.dueDate === "no_date" ? "#45048a" : "transparent",
                            color: filters.dueDate === "no_date" ? "#fff" : "#000",
                          }}
                          onClick={() => setFilters({ ...filters, dueDate: "no_date" })}
                        >
                          No date
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="dropdown-submenu">
                    <button
                      className="dropdown-item d-flex align-items-center justify-content-between"
                      style={{ padding: "8px 4px", fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowDueDateSubmenu(false);
                        setPrioritySubmenu(!showPrioritySubmenu);
                        setProgressSubmenu(false);
                        setBucketsSubmenu(false);
                        setAssignmentSubmenu(false);
                      }} >
                      <div className="d-flex align-items-center">
                        <img src="./profile.png" alt="profile" className="profile-img" style={{ height:"15px", width:"auto", marginRight:"8px" }}/> 
                        Priority
                      </div>
                      <img src="./arrow.png" alt="arrow" style={{height:"14px", width:"auto"}} />
                    </button>

                    {showPrioritySubmenu && (
                      <div
                        className="dropdown-menu show shadow rounded-3 p-2"
                        style={{ position: "absolute", top: "0", right: "105%", border: "1px solid #e9eaeb" }}
                      >
                        {priorities.map(p => (
                          <button
                            key={p}
                            className="dropdown-item"
                            style={{
                              backgroundColor: filters.priority === p ? "#45048a" : "transparent",
                              color: filters.priority === p ? "#fff" : "#000",
                            }}
                            onClick={() => setFilters({ ...filters, priority: p })}
                          >
                            {p.charAt(0).toUpperCase() + p.slice(1)} {/* capitalize */}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="dropdown-submenu">
                    <button
                      className="dropdown-item d-flex align-items-center justify-content-between"
                      style={{ padding: "8px 4px", fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowDueDateSubmenu(false);
                        setPrioritySubmenu(false);
                        setProgressSubmenu(!showProgressSubmenu);
                        setBucketsSubmenu(false);
                        setAssignmentSubmenu(false);
                      }} >
                      <div className="d-flex align-items-center">
                        <img src="./profile.png" alt="profile" className="profile-img" style={{ height:"15px", width:"auto", marginRight:"8px" }}/> 
                        Progress
                      </div>
                      <img src="./arrow.png" alt="arrow" style={{height:"14px", width:"auto"}} />
                    </button>

                    {showProgressSubmenu && (
                      <div
                        className="dropdown-menu show shadow rounded-3 p-2"
                        style={{ position: "absolute", top: "0", right: "105%", border: "1px solid #e9eaeb" }}
                      >
                        {progressOptions.map(s => (
                          <button
                            key={s}
                            className="dropdown-item"
                            style={{
                              backgroundColor: filters.progress === s ? "#45048a" : "transparent",
                              color: filters.progress === s ? "#fff" : "#000",
                            }}
                            onClick={() => setFilters({ ...filters, progress: s })}
                          >
                            {s}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* <div className="dropdown-submenu">
                    <button
                      className="dropdown-item d-flex align-items-center justify-content-between"
                      style={{ padding: "8px 4px", fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setLabelsSubmenu(!showLabelsSubmenu);
                      }} >
                      <div className="d-flex align-items-center">
                        <img src="./profile.png" alt="profile" className="profile-img" style={{ height:"15px", width:"auto", marginRight:"8px" }}/> 
                        Labels
                      </div>
                      <img src="./arrow.png" alt="arrow" style={{height:"14px", width:"auto"}} />
                    </button>

                    {showLabelsSubmenu && (
                      <div
                        className="dropdown-menu show shadow rounded-3 p-2"
                        style={{ position: "absolute", top: "0", right: "105%", marginLeft: "5px", border: "1px solid #e9eaeb" }}
                      >
                        <button className="dropdown-item">Low</button>
                        <button className="dropdown-item">Medium</button>
                        <button className="dropdown-item">High</button>
                      </div>
                    )}
                  </div> */}

                  <div className="dropdown-submenu">
                    <button
                      className="dropdown-item d-flex align-items-center justify-content-between"
                      style={{ padding: "8px 4px", fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowDueDateSubmenu(false);
                        setPrioritySubmenu(false);
                        setProgressSubmenu(false);
                        setBucketsSubmenu(!showBucketsSubmenu);
                        setAssignmentSubmenu(false);
                      }} >
                      <div className="d-flex align-items-center">
                        <img src="./profile.png" alt="profile" className="profile-img" style={{ height:"15px", width:"auto", marginRight:"8px" }}/> 
                        Buckets
                      </div>
                      <img src="./arrow.png" alt="arrow" style={{height:"14px", width:"auto"}} />
                    </button>

                    {showBucketsSubmenu && (
                      <div
                        className="dropdown-menu show shadow rounded-3 p-2"
                        style={{ position: "absolute", top: "0", right: "105%", marginLeft: "5px", border: "1px solid #e9eaeb" }}
                      >
                        {buckets.map(bucket => (
                          <button
                            key={bucket.id}
                            className="dropdown-item"
                            style={{
                              backgroundColor: filters.bucket === bucket.id ? "#45048a" : "transparent",
                              color: filters.bucket === bucket.id ? "#fff" : "#000",
                            }}
                            onClick={() => setFilters({ ...filters, bucket: bucket.id })}
                          >
                            {bucket.name}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="dropdown-submenu">
                    <button
                      className="dropdown-item d-flex align-items-center justify-content-between"
                      style={{ padding: "8px 4px", fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}
                      
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowDueDateSubmenu(false);
                        setPrioritySubmenu(false);
                        setProgressSubmenu(false);
                        setBucketsSubmenu(false);
                        setAssignmentSubmenu(!showAssignmentSubmenu);
                      }} >
                      <div className="d-flex align-items-center">
                        <img src="./profile.png" alt="profile" className="profile-img" style={{ height:"15px", width:"auto", marginRight:"8px" }}/> 
                        Assignment
                      </div>
                      <img src="./arrow.png" alt="arrow" style={{height:"14px", width:"auto"}} />
                    </button>

                    {showAssignmentSubmenu && (
                      <div
                        className="dropdown-menu show shadow rounded-3 p-2"
                        style={{ position: "absolute", top: "0", right: "105%", marginLeft: "5px", border: "1px solid #e9eaeb", minWidth: "220px" }}
                      >
                        {users.map(user => {
                          const isSelected = filters.assignment === user.id;
                          return (
                            <button
                              key={user.id}
                              className="dropdown-item d-flex align-items-center"
                              style={{
                                backgroundColor: isSelected ? "#45048a" : "transparent",
                                color: isSelected ? "#fff" : "#000",
                              }}
                              onClick={() => setFilters({ ...filters, assignment: user.id })}
                            >
                              <img
                                src={user.profile_pic ? `https://teams.tidyds.com${user.profile_pic}` : "https://github.com/mdo.png"}
                                alt={user.name}
                                className="rounded-circle me-2"
                                style={{ width: "28px", height: "28px", objectFit: "cover" }}
                              />
                              <div className="text-start">
                                <div className="fw-semibold">{user.name}</div>
                                <small style={{ color: isSelected ? "#fff" : "#6c757d" }}>
                                  {user.email}
                                </small>
                              </div>
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Notification Bell */}
            <button title="Notification" className="btn position-relative" style={{paddingLeft:"16px" , paddingRight:"16px", border:"none"}}>
              <img src="./Icon.png" alt="notification" />  
            </button>

            {/* Profile Dropdown */}
            <div className="dropdown" ref={dropdownRefProfile}>
              <button
                className="btn p-0 border-0"
                onClick={() => setShowDropdown(!showDropdown)}
              >
                <img
                  src={admin.profilePic}
                  alt="Profile"
                  width="36"
                  height="36"
                  className="rounded-circle profile-hover"
                />
              </button>
              {showDropdown && (
                <div 
                  className="dropdown-menu dropdown-menu-end show  shadow rounded-3 p-3" 
                  style={{ top:"64px", right:"0px", border:"1px solid #e9eaeb" }}
                >
                  {/* Personal Info */}
                  <p style={{ fontSize:"14px", fontWeight:"400", lineHeight:"22px", color:"#4a4a4a"}}>Personal info</p>
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src={admin.profilePic}
                      alt="Profile"
                      width="48"
                      height="48"
                      className="rounded-circle me-2"
                    />
                    <div>
                      <h6 className="mb-0 fw-semibold">{admin.name}</h6>
                      <small className="text-muted">{admin.email}</small>
                    </div>
                  </div>

                  <hr className="my-2" />

                  {/* Action Items */}
                  <button
                    className="dropdown-item d-flex align-items-center "
                    onClick={() => setShowProfileModal(true)}
                    style={{ padding:"8px 4px", fontSize:"14px", fontWeight:"400", lineHeight:"22px"}}
                  >
                    <img src="./profile.png" alt="profile" className="profile-img" style={{ height:"15px", width:"auto", marginRight:"8px"}}/> Change profile
                  </button>
                  <button
                    className="dropdown-item d-flex align-items-center py-2"
                    onClick={() => setChangePasswordMode(true)}
                    style={{ padding:"8px 4px", fontSize:"14px", fontWeight:"400", lineHeight:"22px"}}
                  >
                    <img src="./forgot.png" alt="profile" className="profile-img" style={{ height:"15px", width:"auto", marginRight:"8px"}}/> Change password
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => navigate("/user-management")}
                    style={{ padding:"8px 4px", fontSize:"14px", fontWeight:"400", lineHeight:"22px"}}
                  >
                    <img src="./profile.png" alt="profile" className="profile-img" style={{ height:"15px", width:"auto", marginRight:"8px"}}/>User Management
                  </button>
                  <button
                    className="dropdown-item d-flex align-items-center py-2"
                    onClick={handleLogout}
                    style={{ padding:"8px 4px", fontSize:"14px", fontWeight:"400", lineHeight:"22px"}}
                  >
                    <img src="./sing-out.png" alt="profile" className="profile-img" style={{ height:"15px", width:"auto", marginRight:"8px"}}/> Sign out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* ✅ Profile update Modal (Exact UI) */}
      {showProfileModal && (
        <div className="modal fade show d-block" style={{background:"#00000075"}} tabIndex="-1">
          <div className="modal-dialog " style={{ top:"64px"}}>
            <div className="modal-content shadow-sm text-center" style={{padding:"40px", border:"1px solid #e9eaeb", borderRadius:"8px", width:"fit-content"}}>

              {/* Profile Image */}
              <div className="d-flex justify-content-center mb-3">
                <img
                  src={
                    profileData.profilePic
                      ? URL.createObjectURL(profileData.profilePic)
                      : admin.profilePic
                  }
                  alt="Profile"
                  width="100"
                  height="100"
                  className="rounded-circle border"
                  style={{objectFit:"cover"}}
                />
              </div>

              {/* Upload Box */}
              <label
                htmlFor="profilePicUpload"
                className="d-flex flex-column align-items-center justify-content-center  mb-3 profile-label"
                style={{ cursor: "pointer", width:"320px", borderStyle: "dashed", padding:"10px", border:"1px dashed", borderRadius:"8px",alignSelf:"center"}}
              >
                <i className="bi bi-upload fs-5 mb-1"></i>
                <span className="fw-semibold "><img src="./upload.png" alt="profile" style={{ width:"18px", height:"18px", marginRight:"10px",marginTop:"-4px"}}/>Upload Image</span>
              </label>
              <input
                id="profilePicUpload"
                type="file"
                name="profilePic"
                accept="image/png, image/jpeg"
                className="d-none"
                onChange={handleProfileChange}
              />
              {/* 🚨 File Error Message */}
              {fileError && (
                <div
                  className="text-danger small fw-semibold mb-2"
                  style={{
                    width: "320px",
                    alignSelf: "center",
                    textAlign: "start",
                    border: "1px solid red",
                    padding: "6px 10px",
                    borderRadius: "6px",
                    backgroundColor: "#fff5f5",
                  }}
                >
                  {fileError}
                </div>
              )}
              {/* Upload Notes */}
              <div className=" small text-start" style={{ width:"320px", alignSelf:"center", marginBottom:"32px"}}>
                <p style={{marginBottom:"6px", fontSize:"14px", fontWeight:"400", lineHeight:"18px"}}>*Required dimension : 100 x 100</p>
                <p style={{marginBottom:"0px", fontSize:"14px", fontWeight:"400", lineHeight:"18px"}}>*Supported file : JPG, PNG (max size 200KB)</p>
              </div>

              {/* Footer Buttons */}
              <div className="d-flex justify-content-center">
                <button
                  className="btn rounded p-b"
                  onClick={() => setShowProfileModal(false)}
                  style={{ border: "1px solid #45048a", color: "#6f42c1", fontSize:"16px", fontWeight:"700", lineHeight:"24px", padding:"8px 60px", marginRight:"32px" }}
                >
                  Cancel
                </button>
                <button
                  className="btn p-b"
                  onClick={handleProfileUpdate}
                  style={{ backgroundColor: "#45048a", color: "#fff", fontSize:"16px", fontWeight:"700", lineHeight:"24px", padding:"8px 60px" }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* ✅ Change Password Modal with Old Password Verification */}
      {changePasswordMode && (
        <div className="modal fade show d-block" style={{ background: "#00000075" }} tabIndex="-1">
          <div className="modal-dialog" style={{ top: "64px" }}>
            <div className="modal-content shadow-sm" style={{ padding: "40px", border: "1px solid #e9eaeb", borderRadius: "4px", width: "420px" }}>
              
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="mb-0 fw-bold">Change password</h5>
                <button type="button" className="btn-close" onClick={() => setChangePasswordMode(false)} />
              </div>

              <div className="modal-body p-0">
                {/* Current Password */}
                {!oldPasswordVerified ? (
                  <div className=" text-start">
                    <label className="form-label">Current Password</label>
                    <input
                      type="password"
                      name="oldPassword"
                      className={`form-control ${touched && !profileData.oldPassword ? "is-invalid" : ""}`}
                      placeholder="Enter Current Password"
                      value={profileData.oldPassword}
                      onChange={handleProfileChange}
                      onBlur={() => setTouched(true)} // 👈 only mark invalid after blur
                    />
                    {touched && !profileData.oldPassword && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                        Enter a valid password
                      </div>
                    )}
                    <button
                      className="btn btn-secondary w-100 mt-3 p-b"
                      style={{ backgroundColor: "#45048a", color: "#fff", fontSize:"16px", fontWeight:"700", lineHeight:"24px", padding:"8px 60px" }}
                      onClick={() => {
                        setTouched(true); // 👈 force error if empty
                        if (profileData.oldPassword) verifyOldPassword();
                      }}
                    >
                      Verify Password
                    </button>

                  </div>
                ) : (
                  <>
                    {/* New Password */}
                    <div className="mb-3 text-start">
                      <label className="form-label">New Password</label>
                      <input
                        type="password"
                        name="newPassword"
                        className={`form-control ${passwordErrors.newPassword ? "is-invalid" : ""}`}
                        placeholder="Enter New Password"
                        value={profileData.newPassword}
                        onChange={handleProfileChange}
                      />
                      {passwordErrors.newPassword && (
                        <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                          {passwordErrors.newPassword}
                        </div>
                      )}
                    </div>

                    {/* Confirm Password */}
                    <div className="mb-4 text-start">
                      <label className="form-label">Confirm New Password</label>
                      <input
                        type="password"
                        name="confirmPassword"
                        className={`form-control ${passwordErrors.confirmPassword ? "is-invalid" : ""}`}
                        placeholder="Confirm Password"
                        value={profileData.confirmPassword}
                        onChange={handleProfileChange}
                      />
                      {passwordErrors.confirmPassword && (
                        <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                          {passwordErrors.confirmPassword}
                        </div>
                      )}
                    </div>

                    {/* Save Button */}
                    <button
                      className="btn w-100"
                      onClick={handleProfileUpdate}
                      style={{
                        backgroundColor: "#45048a",
                        color: "#fff",
                        fontWeight: "600",
                        borderRadius: "6px",
                        padding: "10px"
                      }}
                    >
                      Change Password
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}



      <div style={{ paddingTop: "90px" }}>
        <KanbanBoard filters={filters}/>
      </div>
      <ToastContainer position="top-right" autoClose={4000} />
    </div>
  );
};

export default UserDashboard;